import React, {useCallback, useEffect, useState, useTransition} from "react";
import Cohort from "./cohort/Cohort";
import CountrySelect from "../../shared/components/common/CountrySelect";
import PlatformSelect from "../../shared/components/common/PlatformSelect";
import MonthSelect from "../../shared/components/date/MonthSelect";
import dayjs from "dayjs";
import {internalApi} from "../../common/axios";
import {buildUrl} from "../../shared/utils/net";
import { Card } from "antd";
import { PLATFORM } from "../../shared/utils/enum";

const Retentions = () => {
    const [data, setData] = useState({});
    const [yearMonth, setYearMonth] = useState(dayjs().date() < 3 ? dayjs().subtract(1, 'month').format('YYYY-MM') : dayjs().format('YYYY-MM'));
    const [country, setCountry] = useState('ALL');
    const [platform, setPlatform] = useState(PLATFORM.ALL);
    const [inPending, startTransition] = useTransition();

    const handleChangeCountry = (newValue) => {
        setCountry(newValue);
    }

    const fetchData = useCallback(async () => {
        const start = dayjs(yearMonth).startOf('month').format('YYYY-MM-DD');
        const end = dayjs(yearMonth).endOf('month').format('YYYY-MM-DD');

        const res = await internalApi.get(buildUrl('manager/analysis/retention', {country, platform, start, end}));
        const sortedKeys = Object.keys(res.data.rows).sort((a, b) => new Date(b) - new Date(a));
        const sortedData = sortedKeys.reduce((acc, key) => {
            acc[key] = res.data.rows[key];
            return acc;
        }, {});
        setData(sortedData);
    }, [yearMonth, country, platform]);

    useEffect(() => {
        startTransition(async () => await fetchData());
    }, [fetchData, country, platform]);

    if (inPending) {
        return <div>Loading...</div>;
    }

    const headerFormatter = (obj) => {
        if (obj.index === undefined) return "Days";
        if (obj.index === 0) return "가입자 수";
        if (obj.index >= 2 && obj.index <= 8) return `Day ${obj.index - 1}`;
        if (obj.index === 9) return "Day 14";
        if (obj.index === 10) return "Day 30";
    };

    return (
        <Card style={{ margin: 16 }}>
            <div style={{ padding: 16 }}>
                <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px', justifyContent: 'space-between'}}>
                    <div style={{display: 'flex'}}>
                        <CountrySelect country={country} setCountry={handleChangeCountry}/>
                        <PlatformSelect platform={platform} setPlatform={setPlatform}/>
                    </div>
                    <MonthSelect yearMonth={yearMonth} setYearMonth={setYearMonth}/>
                </div>
                <Cohort title='Retention (UTC+9)' data={data} headerFormatter={headerFormatter}/>
            </div>
        </Card>
    )
}

export default Retentions;